import { FC, useEffect } from "react";
import "../CSS/CalendarDetailScreen.css";
import backIcon from "../../../assets/images/back-icon.svg";
import locationIcon from "../../../assets/images/location-icon.svg";
import starIcon from "../../../assets/images/communicate-star-icon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import ImageCarousel from "components/elements/ImageCarousel";
import { CALENDAR_RESERVATION_TYPE, MENU_ITEM } from "utils/constants";
import { useTabBar } from "services/TabBarProvider";
import { IMAGE_LINK, WEB_LINK } from "utils/strings";
import { useLogout } from "services/LogoutProvider";
import ROUTE_PATHS from "utils/routePaths";
import { trackDetailView } from "utils/analytics";

const CommunicateSpaceDetailScreen: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setSelectedTabBar } = useTabBar();
  const { handleAppExit } = useLogout();

  useEffect(() => {
    trackDetailView("communicate_space", "COMMUNICATE_SPACE");
  }, []);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handleReserveClick = () => {
    const fromPath = (location.state as { from?: string } | null)?.from;
    if (
      fromPath === ROUTE_PATHS.WSM_UR_MEMBERSHIP_PLAN_DETAIL ||
      fromPath === ROUTE_PATHS.WSM_MEMBERSHIP_PLAN_DETAIL
    ) {
      navigate(-2);
    } else {
      navigate(-1);
    }
    sessionStorage.setItem(
      "calendarSelectedTab",
      CALENDAR_RESERVATION_TYPE.MEETING_ROOMS,
    );
    setSelectedTabBar(MENU_ITEM.CALENDAR);
  };

  const openWorkspaceLocation = () => {
    handleAppExit(WEB_LINK.SABE_LOCATION);
  };

  return (
    <div className="wms-mobile-container">
      <div className="calendar_detail-screen-container">
        <div className="calendar_detail-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <span>
            Communicate <span style={{ color: "#ff6b35" }}>Space</span>
          </span>
        </div>
        <div
          className="calendar-detail-banner-image-container"
          style={{ backgroundImage: `url(${IMAGE_LINK.COMMUNICATE_SPACE})` }}
        ></div>
        <div className="calendar_detail-date-location-container">
          <div className="detail-container">
            <div className="image">
              <img src={locationIcon} alt="location-logo" />
            </div>
            <div className="right-container">
              <div className="sub-container">
                <span>SabeHub, Mohali</span>
                <span className="sub-text">SCO-3, 2nd Floor, Sec-68</span>
              </div>
              <button onClick={openWorkspaceLocation}>Direction</button>
            </div>
          </div>
        </div>
        <div className="calendar_detail-container">
          <span>
            About <span style={{ color: "#ff6b35" }}>Communicate Space</span>
          </span>
          <div className="divider"></div>
          <div className="communicate_space_container ">
            <span style={{ color: "#ff6b35" }}>Description</span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Communicate Space is built
              for the work that needs people.
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Use it when you need to
              meet, align, brainstorm, present, review, or make decisions with
              your team, client, or collaborator.
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> From private two-person
              pods to small team rooms, Communicate Space gives you the privacy,
              tools, and setting to make conversations more focused and useful.
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Come here when the work
              needs to be shared, sharpened, or decided.
            </span>
            <span style={{ marginTop: "10px", color: "#ff6b35" }}>
              Key Benefits
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Turn conversations into
              alignment, not confusion.
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Meet privately without
              disturbing your focus or the larger workspace.
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Make calls, reviews,
              presentations, and decisions feel sharper and more professional.
            </span>
            <span style={{ marginTop: "10px", color: "#ff6b35" }}>
              Features
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Private meeting pods and
              small team rooms.
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Whiteboards and screens
              where available.
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> 50-minute booking slots
              designed for focused, time-bound conversations.
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Designed for focused
              conversations, clearer agendas, sharper roles, and better
              decisions.
            </span>
          </div>
        </div>
        <div className="calendar_detail-contact-detail-container">
          <ImageCarousel
            images={[
              IMAGE_LINK.COMMUNICATE_SPACE_1,
              IMAGE_LINK.COMMUNICATE_SPACE_2,
            ]}
            title="In Real"
            subTitle="Life"
          />
        </div>
        <button
          className="calendar_detail-reserve-btn"
          onClick={handleReserveClick}
        >
          Reserve
        </button>
      </div>
    </div>
  );
};

export default CommunicateSpaceDetailScreen;
